// @ts-nocheck
import { toastTypes } from '../../enums';
import { createOAuthIntegrationStore } from './_shared';

export default createOAuthIntegrationStore({
  partnerKey: 'HubSpot',
  defaultConfigs: { enabled: false },
  toastKeys: { update: toastTypes.hubSpotUpdateConfigs, tokens: toastTypes.getTokens },
  successMessages: { tokens: 'HubSpot integration successful.' },
});
